import axios from 'axios'
import { string } from 'prop-types'
import { AsyncStorage } from 'reactjs-async-localstorage'

const API_AUTHORIZATION = process.env.REACT_APP_AUTHORIZATION
const API_SERVER_DATA_URL = process.env.REACT_APP_SERVER_TOKEN_URL

const SESSION_TOKEN = process.env.REACT_APP_LOCAL_TOKEN_NAME
const SESSION_REFRESHTOKEN = process.env.REACT_APP_LOCAL_REFRESH_TOKEN_NAME

const TOKEN_URL = `${API_SERVER_DATA_URL}/token`
const REFRESH_TOKEN_URL = `${API_SERVER_DATA_URL}/refresh_token`
const VERIFY_TOKEN_URL = `${API_SERVER_DATA_URL}/verify_token`
const REMEMBER_URL = `${API_SERVER_DATA_URL}/remember`

const defaultSign = {
  signed: false,
  data: {
    user_key: 0,
    user_id: '',
    user_email: '',
    user_name: '',
    user_role: '',
    create_date: '',
    token_expiration_date: '',
    token: '',
    refresh_token_expiration_date: '',
    refresh_token: '',
  },
  error: {},
}

const Auth = {
  token: async (username = string.isRequired, password = string.isRequired) =>
    await axios
      .post(
        TOKEN_URL,
        {
          username: username,
          password: btoa(password),
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: API_AUTHORIZATION,
          },
        },
      )
      .then(res => ({
        signed: true,
        data: res.data,
        error: {},
      }))
      .catch(err => ({
        signed: false,
        data: defaultSign.data,
        error: err.response,
      })),
  verifyToken: async () => {
    // Grava o token na seção do usuário
    const _token = await AsyncStorage.getItem(SESSION_TOKEN)

    // Grava o refresh token na seção do usuário
    const _refreshToken = await AsyncStorage.getItem(SESSION_REFRESHTOKEN)

    // Se o token existe verifica no servidor a validação do token
    if (_token && _refreshToken) {
      // Se o token existe verifica no servidor a validação do token
      return await axios
        .post(
          VERIFY_TOKEN_URL,
          { token: _token, refresh_token: _refreshToken },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: API_AUTHORIZATION,
            },
          },
        )
        .then(res => ({
          signed: true,
          data: res.data,
          error: {},
        }))
        .catch(err => ({
          signed: false,
          data: defaultSign.data,
          error: err.response,
        }))
    } else {
      return defaultSign
    }
  },
  registerToken: async (token = string.isRequired, refreshtoken = string.isRequired) => {
    // Grava o token na seção do usuário
    await AsyncStorage.setItem(SESSION_TOKEN, token)

    // Grava o refresh token na seção do usuário
    await AsyncStorage.setItem(SESSION_REFRESHTOKEN, refreshtoken)
  },
  refreshToken: async (token = string.isRequired, refreshtoken = string.isRequired) => {
    return new Promise((resolve, reject) => {
      try {
        axios
          .post(
            REFRESH_TOKEN_URL,
            { token: token, refresh_token: refreshtoken },
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: API_AUTHORIZATION,
              },
            },
          )
          .then(async res => {
            localStorage.setItem(process.env.REACT_APP_LOCAL_TOKEN_NAME, res.data.token)
            localStorage.setItem(
              process.env.REACT_APP_LOCAL_REFRESH_TOKEN_NAME,
              res.data.refresh_token,
            )
            // Fazer algo caso seja feito o refresh token
            return resolve(res)
          })
          .catch(err => {
            // Fazer algo caso não seja feito o refresh token
            return reject(err)
          })
      } catch (err) {
        return reject(err)
      }
    })
  },
  //Remove o token e as informações do usuário
  removeToken: async () => {
    // Remove o token na seção do usuário
    await AsyncStorage.removeItem(SESSION_TOKEN)
    await AsyncStorage.removeItem(SESSION_REFRESHTOKEN)
  },
  remember: async ({ cpf = string.isRequired, email = string.isRequired }) =>
    // Remove o token na seção do usuário
    await axios
      .get(`${REMEMBER_URL}/${cpf}/${email}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: API_AUTHORIZATION,
        },
      })
      .then(res => res.data),
}

export default Auth
